import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@Contexts/Request';
import useNavigation from '@Navigation/useNavigation';
import { useDeps } from '@Contexts/DI';

interface AIControlData {
  sort: {
    name: string;
    id: number;
  };
}

function useAICategoryControl() {
  const { aiPageControl } = useDeps();
  const { pathname } = useNavigation();
  const request = useRequest();
  const region = request.region || request.mainRegion;
  const keys = ['aiCategoryControl', region, pathname];
  const sortIDs = {
    mostPopular: 0,
    new: 5,
    cheapest: 1,
    mostExpensive: 2,
    discount: 4,
    default: null,
  };

  const initialData: AIControlData = {
    sort: { name: 'default', id: sortIDs.default },
  };

  const { data } = useQuery({
    queryKey: keys,
    queryFn: async () => {
      if (!window.ninja || !aiPageControl) return initialData;

      const aiSorting = await aiPageControl.getCategorySorting();
      return {
        sort: aiSorting
          ? {
              name: aiSorting,
              id: sortIDs[aiSorting],
            }
          : initialData,
      };
    },
    placeholderData: (previousData) => previousData || initialData,
  });

  return data as AIControlData;
}

export default useAICategoryControl;
